import React from 'react';

function FileImage() {
  return (
    <div>
      <svg
        width="33"
        height="32"
        viewBox="0 0 33 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M28.1641 8H19.4978L16.0303 5.4C15.6836 5.14132 15.2629 5.00107 14.8303 5H9.16406C8.63363 5 8.12492 5.21071 7.74985 5.58579C7.37478 5.96086 7.16406 6.46957 7.16406 7V9H5.16406C4.63363 9 4.12492 9.21071 3.74985 9.58579C3.37478 9.96086 3.16406 10.4696 3.16406 11V25C3.16406 25.5304 3.37478 26.0391 3.74985 26.4142C4.12492 26.7893 4.63363 27 5.16406 27H24.2753C24.776 26.9993 25.2561 26.8001 25.6101 26.4461C25.9642 26.092 26.1634 25.612 26.1641 25.1112V23H28.2753C28.776 22.9993 29.2561 22.8001 29.6101 22.4461C29.9642 22.092 30.1634 21.612 30.1641 21.1112V10C30.1641 9.46957 29.9533 8.96086 29.5783 8.58579C29.2032 8.21071 28.6945 8 28.1641 8ZM28.1641 21H26.1641V14C26.1641 13.4696 25.9533 12.9609 25.5783 12.5858C25.2032 12.2107 24.6945 12 24.1641 12H15.4978L12.0303 9.4C11.6836 9.14132 11.2629 9.00107 10.8303 9H9.16406V7H14.8303L18.5641 9.8C18.7372 9.92982 18.9477 10 19.1641 10H28.1641V21Z"
          fill="var(--color-primary)"
        />
      </svg>
    </div>
  );
}

export default FileImage;
